import Vue from "vue";
import App from "./App.vue";
import BootstrapVue from "bootstrap-vue";
import VueRouter from "vue-router";
import Vuex from "vuex";
import VTooltip from "v-tooltip";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "vue2-animate/dist/vue2-animate.min.css";
import "./styles/animate.css";
import "./styles/style.scss";
import Home from "./components/Home";
import FiresafeSelector from "./components/FiresafeSelector";
import InfoShips from "./components/InfoShips";
import DownloadReports from "./components/DownloadReports";
import Page from "./components/Page";
import DataVis from "./components/DataVis";

Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.use(VueRouter);
Vue.use(Vuex);
Vue.use(VTooltip);

const routes = [
  { path: "/", component: Home },
  { path: "/select", component: FiresafeSelector },
  {
    path: "/download-reports",
    component: Page,
    children: [
      { path: "", component: DownloadReports },
      { path: "/ship-info", component: InfoShips }
    ]
  },
  {
    path: "/firesafe-:number/:type/",
    component: DataVis
  }
];

const router = new VueRouter({
  routes
});

const store = new Vuex.Store({
  state: {
    background: null,
    ship: false,
    waves: false,
    pageClass: null,
    firesafe: {
      number: 0,
      type: null,
      selectedRCO: 0
    },
    animations: {
      expandAnim: false,
      fadeInDown: true
    }
  },
  getters: {
    getSelectedRCO(state) {
      return state.firesafe.selectedRCO;
    }
  },
  mutations: {
    setBackground(state, background) {
      state.background = background;
    },
    toggleShip(state, visible) {
      state.ship = visible;
    },
    toggleWaves(state, visible) {
      state.waves = visible;
    },
    setPageClass(state, myclass) {
      state.pageClass = myclass;
    },
    setFiresafeNumber(state, number) {
      state.firesafe.number = number;
    },
    setFiresafeType(state, type) {
      state.firesafe.type = type;
    },
    setSelectedRCO(state, selected) {
      state.firesafe.selectedRCO = selected;
    },
    toggleExpand(state, status) {
      state.animations.expandAnim = status;
    },
    toggleFadeInDown(state, status) {
      state.animations.fadeInDown = status;
    }
  }
});

Vue.filter("truncate", function(value, limit) {
  if (value.length > limit) {
    value = value.substring(0, limit - 3) + "...";
  }

  return value;
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
